import Vue from 'vue'
import './plugins/vuetify'
import './filters'
import '@mdi/font/css/materialdesignicons.css'
import App from './App.vue'
import router from './router'
import store from './store'
import Api from './common/api'
import { CHANGE_DICTIONARY, CHANGE_SOURCE_DICTIONARY } from './store/action-types'

Vue.config.productionTip = false

// define.amd = false

Api.init()

router.beforeEach(async (to, from, next) => {
  if (to.name !== 'login' && !store.state.isAuthenticated) {
    router.push({ name: 'login', query: { target: to.fullPath } })
  } else {
    if (to.meta.sourceDictionaryId) {
      await store.dispatch(CHANGE_SOURCE_DICTIONARY, { sourceDictionaryId: to.meta.sourceDictionaryId })
    }
    if (to.params.sourceDictionaryId) {
      await store.dispatch(CHANGE_SOURCE_DICTIONARY, { sourceDictionaryId: to.params.sourceDictionaryId })
    }
    if (to.params.dictionaryId) {
      await store.dispatch(CHANGE_DICTIONARY, { dictionaryId: to.params.dictionaryId })
    }
    next()
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
